export enum ButtonSize {
   Small = "small",
   Normal = "normal",
   Large = "large"
}

export enum ButtonType {
   Primary = "primary",
   Secondary = "secondary",
   Link = "link",
   Danger = "danger",
   Accent = "accent"
}

export enum ButtonVariant {
   Icon = "icon"
}
